const generateForm04 = [
  {
    label: "ได้รับหมายเรียกของ",
    name: "received_summons",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ที่",
    name: "received_summons_address",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ลงวันที่",
    name: "received_summons_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_type",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },

  {
    label: "ให้เข้ารับการ",
    name: "received_summons_receive",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 6 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ณ ที่",
    name: "received_summons_place",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 6 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ตั้งแต่วันที่",
    name: "received_summons_since_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "มีกำหนด (วัน)",
    name: "received_summons_scheduled_date",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
];

export default generateForm04;
